// @core/api/endpoints/workflow/test_credential.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TestCredentialRequest,
  TestCredentialResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Test credential
 * Tests a credential by attempting to use its secrets (e.g. SMTP connect, OAuth token refresh). Returns verification result.
 */
export async function TestCredential(
  credential_id: string,
  data: TestCredentialRequest,
  options?: RequestOptions
): Promise<TestCredentialResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/credentials/:credential_id/test`;
  requestPath = requestPath.replace(':credential_id', encodeURIComponent(credential_id));
  const requestOptions = options;
  return client.post<TestCredentialResponse>(requestPath, data, requestOptions);
}
